var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
var PhoneNumberValidatorDirective = /** @class */ (function () {
    function PhoneNumberValidatorDirective() {
        this.validator = this.validatPhoneNumberFactory();
    }
    PhoneNumberValidatorDirective_1 = PhoneNumberValidatorDirective;
    PhoneNumberValidatorDirective.prototype.validatPhoneNumberFactory = function () {
        return function (c) {
            if (c.value == null) {
                return null;
            }
            var REGEXP = /^1[3456789][0-9]{9}$/;
            return REGEXP.test(c.value) ? null :
                { 'isWrong': true };
        };
    };
    PhoneNumberValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    var PhoneNumberValidatorDirective_1;
    PhoneNumberValidatorDirective = PhoneNumberValidatorDirective_1 = __decorate([
        Directive({
            selector: '[validator-phone-number][ngModel]',
            providers: [
                { provide: NG_VALIDATORS, useExisting: forwardRef(function () { return PhoneNumberValidatorDirective_1; }), multi: true }
            ]
        })
    ], PhoneNumberValidatorDirective);
    return PhoneNumberValidatorDirective;
}());
export { PhoneNumberValidatorDirective };
